import { useEffect } from 'react';

import { useAppSelector } from '@/context/storeHooks';
import { selectIsLoggedIn } from '@/context/user';
import {
    ELocalStorageVariables,
    getLocalStorageItem,
} from '@/utils/localStorage';
import { EEvents, subscribeToSseEvent } from '@/utils/subscribeToSseEvent';

interface Props {
    eventName: EEvents;
    onOpen?: () => void;
    onMessage: (message: any) => void;
    onError?: (error: any) => void;
}

export function EventSubscriber({
    eventName,
    onOpen,
    onMessage,
    onError,
}: Props): JSX.Element {
    const isLoggedIn = useAppSelector(selectIsLoggedIn);

    // Subscribe to SSE event
    useEffect(() => {
        // The token is only checked for PRESENCE, to avoid minting a ticket for
        // a visitor who has not logged in yet. This component used to decode the
        // JWT here and pull `borrowerId` out to put in the stream URL; it no
        // longer does, because the relay took that id on trust. The identity now
        // comes from the ticket the API mints against the session, which is the
        // one place it cannot be asserted by whoever is asking.
        const token = getLocalStorageItem(ELocalStorageVariables.AUTH_TOKEN);

        if (!token) {
            return;
        }

        const connection = subscribeToSseEvent(
            eventName,
            onMessage,
            onError,
            onOpen
        );

        // Close connection on component dismount
        return () => {
            connection.close();
        };
    }, [isLoggedIn]);

    // Empty div to render nothing
    return <></>;
}
